<mat-dialog-content class="dialog-content">
  <div class="upload-container">
    <span class="upload-title">Selecione as imagens</span>
    <div class="dropzone-wrapper">
    <div
      class="dropzone-container"
      [dropzone]="config"
      [class.drag-active]="isDragging"
      (dragenter)="onDragEnter($event)"
      (dragleave)="onDragLeave($event)"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
    >
      <div class="dz-message">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <span> {{isDragging ? 'Solte os arquivos para enviar' : 'Clique ou arraste arquivos para cá para fazer upload, ou '}}</span>
        <br />
        <span class="text-link" *ngIf="!isDragging" (click)="fileInput.click()">
          clique aqui para selecionar
        </span>
        <input
          type="file"
          #fileInput
          multiple
          (change)="onFileSelected($event)"
          accept="image/*"
          hidden
        />
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="warn" (click)="onCancel()">Cancelar</button>
</mat-dialog-actions>